import Utility from '../../../../../../util/utilityfunctions';

import {config as dateColumnConfig} from '../../common/DateColumn';

export const prop = 'relDate';
export const id = 'reportReleaseDateColumn';

export const config = (labels) =>
	dateColumnConfig({
		fullId: id,
		label: labels.reportReleaseDate,
		prop,
		width: 'minmax(var(--px-170), 2fr)',
		isOverdue: (item) => !!Utility.dateIsOverdue(item[prop]) && !item.partInv
	});
